export default __webpack_public_path__ + "static/media/common-myths-banner.d5983e81.jpg";